module.exports = __webpack_public_path__ + "img/10.8d08e92a.svg";